const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/hub.$slug.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { type AppProps, useAppStore } from '@/inertia/AppStore';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { HubFrontendSingleQuery, type Hub_Frontend_Single_Query, type Hub_Frontend_Single_Query$data } from '@/graphql/queries/Hub.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { loadQuery } from 'react-relay';
import { z } from 'zod';
type Props = AppProps & {
  hub: HubType;
  activeHubNavIdx: number;
  activeNodeIdx: number;
};
export type { Props as HubProps };
export const hubSchema = z.object({
  c: z.string().optional().nullable().catch(null),
  nav: z.string().optional().nullable().catch(null),
  s: z.string().optional().nullable().catch(null)
});
export type HubSearch = z.infer<typeof hubSchema>;
export const Route = createFileRoute('/hub/$slug')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: (search): HubSearch => hubSchema.parse(search),
  loader: ({
    params
  }) => {
    return loadQuery<Hub_Frontend_Single_Query>(RelayEnvironment, HubFrontendSingleQuery, {
      id: params.slug,
      idType: 'SLUG'
    }, {
      fetchPolicy: 'store-or-network'
    });
  },
  beforeLoad: ({
    params
  }) => {
    if (!params.slug) {
      throw redirect({
        to: '/*'
      });
    }
  },
  onEnter: () => {
    const store = useAppStore.getState();
    store.resetInertia();
    store.setPageType('hub');
    store.setBarView('list');
    store.setBarTitle('Content');
  }
});